export default __webpack_public_path__ + "static/media/order_average.270ba3c3.svg";